/**
 * The link never reached the customer. Loud on purpose: the row is otherwise
 * indistinguishable from a healthy reservation.
 *
 * THE REMEDY IS PER-STAGE (BON-472), and this section is read-only, so the
 * recoverable case names where the button lives. Every other case gives the
 * answer HERE rather than sending a CSR to another screen to find that button
 * greyed out — which is what "resend it from the Reservations tab" did on a
 * reservation that can no longer be resent at all.
 */
import type { ReservationStage } from '../../../../api/reservations';
import { sendFailedNote } from '../../../bookings/reservationSendFailure';

export function WorkshopReservationSendFailedNote({ stage }: { stage: ReservationStage }) {
  return (
    <div style={{ fontSize: 11, color: 'var(--nb-risk)', marginTop: 2 }}>
      {sendFailedNote(stage, false)}
    </div>
  );
}
